import { useEffect } from 'react';
import { useHistory } from 'react-router-dom';

import ErrorContainer from '@/components/error-handling/app-level/ErrorContainer';
import MainRoutes from '@/components/routes';

import { useErrorContext } from '@/context/Error';

import { page } from '@/lib/analytics';
import { hideHubspotChat, showHubspotChat } from '@/lib/hubspotChat';
import { supressNoisyLogs } from '@/lib/logging';

supressNoisyLogs();

export default function App() {
  // TODO
  // When we start to use Next.js error conventions we will
  // need to rethik thi
  const { appError } = useErrorContext();

  // When routes change, call generic analytics pageview function
  const { listen: onRouteChange } = useHistory();

  onRouteChange(page);

  useEffect(() => {
    // Hide HubSpot messages iframe container
    // ---
    // Re-enforcing the HubSpot chat widget to be hidden when the modal is open,
    // so it doesn't interfere with the modal display.
    const htmlEl = document.documentElement;
    const observer = new MutationObserver(() => {
      if (htmlEl.classList.contains('modal-open')) {
        hideHubspotChat();
      } else {
        showHubspotChat();
      }
    });

    observer.observe(htmlEl, { attributes: true, attributeFilter: ['class'] });

    // Initial check in case modal is already open
    if (htmlEl.classList.contains('modal-open')) {
      hideHubspotChat();
    }

    // Polling logic to ensure HubSpot widget is loaded
    // ---
    // This is a workaround for the HubSpot widget not displaying after
    // the page load, which can cause issues with the chat functionality.

    let pollAttempts = 0;
    const maxPolls = 50;
    const pollInterval = 200;
    let pollTimer = null;

    function pollHubspotWidget() {
      pollAttempts++;
      if (
        window.HubSpotConversations &&
        window.HubSpotConversations.widget &&
        typeof window.HubSpotConversations.widget.status === 'function'
      ) {
        const status = window.HubSpotConversations.widget.status();
        if (
          status &&
          status.loaded === false &&
          typeof window.HubSpotConversations.widget.load === 'function'
        ) {
          window.HubSpotConversations.widget.load();
        }
        // Stop polling once found
        return;
      }
      if (pollAttempts < maxPolls) {
        pollTimer = setTimeout(pollHubspotWidget, pollInterval);
      }
    }

    pollHubspotWidget();

    return () => {
      observer.disconnect();
      if (pollTimer) clearTimeout(pollTimer);
    };
  }, []);

  return (
    <>
      {!appError && <MainRoutes />}
      {!!appError && <ErrorContainer />}
    </>
  );
}
